import { forwardRef, PropsWithoutRef, ReactNode } from "react";
import { ScrollArea } from "../ui/scroll-area";
import { Button, ButtonProps } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";
import { ActionsContext, useEmit } from "@/src/lib/actions";

export function WithActionBar({ actionBar, children }: { actionBar: ReactNode; children?: ReactNode }) {
  return (
    <ActionsContext>
      <div className="h-full w-full grid grid-rows-[auto_88px]">
        <ScrollArea className="scrollarea">{children}</ScrollArea>
        <div className="px-12 py-6 border-t bg-white border-t-blue-100">{actionBar}</div>
      </div>
    </ActionsContext>
  );
}

export function BackButton() {
  const navigate = useNavigate();
  return (
    <Button variant="outline" onClick={() => navigate(-1)}>
      <ChevronLeftIcon size={16} className="mr-2" />
      Back
    </Button>
  );
}

export const ActionButton = forwardRef<HTMLButtonElement, PropsWithoutRef<ButtonProps> & { eventKey: string }>(
  ({ onClick, eventKey, ...props }, ref) => {
    const emit = useEmit(eventKey);
    return (
      <Button
        ref={ref}
        onClick={(ev) => {
          emit();
          onClick?.(ev);
        }}
        {...props}
      />
    );
  },
);
